import React, { useCallback } from "react";
import { useSdkContext } from "~/components/contexts";
import { useGA4CommonParameters, useSendImpressionEvents } from "~/components/rosetta/hooks";
import { StyledAlertIcon, StyledSubscriptionButton } from "./styles";
export const GracePeriodButton = ({
  className
}) => {
  const {
    config,
    handleTrackGA4
  } = useSdkContext();
  const {
    computeGA4CommonParameters
  } = useGA4CommonParameters();
  const {
    captureTrackImpressionEventTargetElement
  } = useSendImpressionEvents({
    ga4Event: useCallback(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...computeGA4CommonParameters(),
        call_to_action: "update payment",
        trigger_point: "masthead grace period renewal failure banner"
      },
      subcategory: "entry_point"
    }), [computeGA4CommonParameters]),
    gaEvent: useCallback(() => ({
      action: "Subscription Grace Period/Masthead/Renewal Failed/Impression",
      category: "Subscription Grace Period",
      label: window.location.href
    }), [])
  });
  return /*#__PURE__*/React.createElement(StyledSubscriptionButton, {
    className: className,
    ref: captureTrackImpressionEventTargetElement,
    onClick: () => {
      handleTrackGA4({
        action: "click",
        category: "subs",
        customized_parameters: {
          ...computeGA4CommonParameters(),
          call_to_action: "update payment",
          trigger_point: "masthead grace period renewal failure banner"
        },
        subcategory: "entry_point"
      });
      window.location.href = `${config.accounts.host}/settings`;
    },
    "data-qa": "grace-period-button"
  }, /*#__PURE__*/React.createElement(StyledAlertIcon, null), "Renewal Failed");
};
GracePeriodButton.displayName = "GracePeriodButton";